import { Avatar, ButtonBase, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { Delete, SmallGreenCheckmark, WatchFile } from 'Images';

interface IFileActions {
  filename: string;
  watchFile: () => void;
  deleteFile: () => void;
}

export const FileActions = (props: IFileActions) => {
  const dictionary = Dictionary[DICTIONARY.General];
  const isDesktop = useIsDesktop();

  return (
    <Stack justifyContent={'space-between'} gap={'10px'}>
      <Stack
        p={'12px'}
        bgcolor={'#FBFCFF'}
        border={'1px solid'}
        borderColor={'primary.shade_200'}
        borderRadius={'8px'}
        direction={'row'}
        gap={'12px'}
        alignItems={'center'}
        justifyContent={'flex-start'}
      >
        <Avatar
          sx={{ width: '24px', height: '24px' }}
          src={SmallGreenCheckmark}
          alt={''}
        />
        <Typography
          variant={'body1'}
          tabIndex={0}
          overflow={'hidden'}
          textOverflow={'ellipsis'}
        >
          {props.filename}
        </Typography>
      </Stack>
      <Stack
        mt={isDesktop ? undefined : '26px'}
        direction={'row'}
        justifyContent={'flex-end'}
        gap={'16px'}
      >
        <ButtonBase sx={{ alignItems: 'flex-end' }} onClick={props.watchFile}>
          <Avatar
            src={WatchFile}
            alt={`${dictionary.watch} ${props.filename}`}
            sx={{ width: '24px', height: '24px' }}
          />
          <Typography variant={'body6'} sx={{ cursor: 'pointer' }}>
            {dictionary.watch}
            <span className='sr-only'>{props.filename}</span>
          </Typography>
        </ButtonBase>
        <ButtonBase sx={{ alignItems: 'flex-end' }} onClick={props.deleteFile}>
          <Avatar
            src={Delete}
            sx={{ width: '24px', height: '24px' }}
            alt={`${dictionary.delete} ${props.filename}`}
          />
          <Typography variant={'body6'}>
            {dictionary.deleteFile}
            <span className='sr-only'>{props.filename}</span>
          </Typography>
        </ButtonBase>
      </Stack>
    </Stack>
  );
};
